import { render, staticRenderFns } from "./AndroidSamsung.vue?vue&type=template&id=26eae85d&scoped=true"
var script = {}
import style0 from "./AndroidSamsung.vue?vue&type=style&index=0&id=26eae85d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eae85d",
  null
  
)

export default component.exports